const q = require('queried');
const events = require('events-mixin');

module.exports = class {
  constructor({ element }) {
    this.element = element;
    this.more = q('.datesList-more', this.element);
    this.less = q('.datesList-less', this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.events = events(this.element, this);
    this.events.bind({
      'click .datesList-more': 'show',
      'click .datesList-less': 'hide',
    });
  }

  show() {
    const rows = q.all('tr', this.element);
    rows.forEach((r) => r.removeAttribute('hidden'));

    this.more.setAttribute('hidden', 'hidden');
    this.less.removeAttribute('hidden');
  }

  hide() {
    const rows = q.all('tr', this.element);
    rows.forEach((r, index) => {
      if (index > 2) {
        r.setAttribute('hidden', 'hidden');
      }
    });

    this.less.setAttribute('hidden', 'hidden');
    this.more.removeAttribute('hidden');
  }
};
